const topicItems = [
  { label: '#狂飙大结局', hot: '987万', color: 'bg-primary-100 text-primary-700' },
  { label: '#庆余年2', hot: '865万', color: 'bg-accent-100 text-accent-700' },
  { label: '#封神第二部', hot: '742万', color: 'bg-secondary-100 text-secondary-700' },
  { label: '#繁花', hot: '698万', color: 'bg-primary-100 text-primary-700' },
  { label: '#长相思', hot: '621万', color: 'bg-accent-100 text-accent-700' },
  { label: '#流浪地球2', hot: '583万', color: 'bg-secondary-100 text-secondary-700' },
  { label: '#唐朝诡事录', hot: '512万', color: 'bg-primary-100 text-primary-700' },
  { label: '#年会不能停', hot: '467万', color: 'bg-accent-100 text-accent-700' },
  { label: '#三大队', hot: '435万', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">全网影视热议焦点，看看大家都在讨论哪些热门内容</p>
        </div>
        <div className="flex flex-wrap gap-2 md:gap-3 justify-center max-w-3xl mx-auto">
          {topicItems.map((item) => (
            <div
              key={item.label}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer ${item.color}`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}